import { toast } from "sonner";
import { Copy, ShoppingBag } from "lucide-react";

const CodeBox = ({ code }) => (
  <button type="button" data-testid="game-code" onClick={() => { navigator.clipboard?.writeText(code); toast.success("Code copied"); }}
    className="w-full rounded-2xl border-2 border-dashed border-[#1B1530] bg-white py-3 font-display text-3xl tracking-wider inline-flex items-center justify-center gap-3">
    {code} <Copy className="h-5 w-5" />
  </button>
);

const NOTE_TEXT = {
  bag: "We'll add a free surprise bag to your next order. It's saved to your cart automatically.",
  box12: "JACKPOT! We'll add a free 12-pack to your next order. Just order anything, even one 6-pack. It's saved to your cart automatically.",
};

export const WinPanel = ({ code, note, prizeKey, onShop }) => (
  <div data-testid="game-win-panel" className="space-y-3">
    {code && <CodeBox code={code} />}
    {note && <p data-testid="game-note" className={`rounded-2xl px-4 py-3 text-sm font-bold text-center ${prizeKey === "box12" ? "bg-[#FFB21A]" : "bg-[#7BD88F]"}`}>{NOTE_TEXT[prizeKey] || NOTE_TEXT.bag}</p>}
    <button data-testid="game-shop-button" onClick={onShop}
      className="w-full h-12 rounded-full bg-[#FF5A5F] text-white font-bold inline-flex items-center justify-center gap-2 hover:bg-[#1B1530] transition-colors">
      <ShoppingBag className="h-4 w-4" /> {code ? "Applied at checkout, build my box" : "Build my box"}
    </button>
  </div>
);
